import i18n from "i18next";
import { FormSelectField } from "src/components/common/forms/fields/FormSelectField";
import { FieldPath, UseControllerProps } from "react-hook-form";
import { SystemDiagramNode } from "src/api/generated/postgres/db/types/public_/tables/systemDiagramNode";
import { SystemDiagramFunctionParamsFormProps } from "./SystemDiagramFunctionParamsForm";

export interface ProductionLineSelectionFieldProps<TFieldName extends FieldPath<SystemDiagramNode>>
	extends SystemDiagramFunctionParamsFormProps {
	fieldName: UseControllerProps<SystemDiagramNode, TFieldName>["name"];
	productionLineIndex?: number;
	label?: string;
}

export const ProductionLineSelectionField = <TFieldName extends FieldPath<SystemDiagramNode>>({
	control,
	fieldName,
	productionLineIndex,
	label,
	formInitialData: { productionLineOptions },
}: ProductionLineSelectionFieldProps<TFieldName>) => {
	return (
		<FormSelectField
			control={control}
			name={fieldName}
			label={
				label ??
				i18n.t("production_line_n", {
					productionLineNo: productionLineIndex,
				})
			}
			options={productionLineOptions.map((p) => ({
				key: p.productionLineId.toString(),
				label: p.productionLineName,
			}))}
		/>
	);
};
